import { IconProps } from '../iconProps';

export const Bulb = ({ size = 15, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.49992 13.978C7.14378 13.978 6.83898 13.8475 6.58555 13.5864C6.33201 13.3255 6.20523 13.0094 6.20523 12.6383H8.79492C8.79492 13.0094 8.6681 13.3255 8.41445 13.5864C8.16091 13.8475 7.85607 13.978 7.49992 13.978ZM5.61758 11.9833C5.4331 11.9833 5.27846 11.9205 5.15367 11.795C5.02888 11.6695 4.96648 11.514 4.96648 11.3284C4.96648 11.144 5.02888 10.9893 5.15367 10.8645C5.27846 10.7397 5.4331 10.6773 5.61758 10.6773H9.38258C9.56706 10.6773 9.72169 10.7397 9.84648 10.8645C9.97128 10.9893 10.0337 11.144 10.0337 11.3286C10.0337 11.5131 9.97128 11.6683 9.84648 11.7944C9.72169 11.9203 9.56706 11.9833 9.38258 11.9833H5.61758ZM5.12273 10.0223C4.38159 9.58037 3.79008 8.98943 3.3482 8.24954C2.90643 7.50953 2.68555 6.70396 2.68555 5.83282C2.68555 4.49657 3.15357 3.36068 4.08961 2.42516C5.02576 1.48974 6.16242 1.02203 7.49961 1.02203C8.8369 1.02203 9.97372 1.48974 10.9101 2.42516C11.8464 3.36068 12.3146 4.49657 12.3146 5.83282C12.3146 6.70646 12.0937 7.51266 11.652 8.25141C11.2101 8.99006 10.6186 9.58037 9.87742 10.0223H5.12273Z'
        fill={fill ?? 'currentColor'}
      />
    </svg>
  );
};
